import { ProgressSpinner } from "primereact/progressspinner";
import { useClients } from "../hooks/queries";
import Dashboard from "../Layout/Dashboard";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useLocation, useNavigate } from "react-router-dom";
import { Dialog } from "primereact/dialog";
import { useState } from "react";

export default function PaymentSelectClient() {
  
  const { data: clients, isLoading } = useClients();
  const location = useLocation();
  const [showDialog, setShowDialog] = useState(
    location.state?.showInsolventDialog || false
  );
  const navigate = useNavigate();
  // const [isAdmin, setIsAdmin] = useState(true);


  // if (!isAdmin) {
  //   return (
  //     <Dashboard headerTitle="Pagos">
  //       <h1 className="text-xl">
  //         Esta sección está en mantenimiento. Por favor, vuelva más tarde.
  //       </h1>
  //     </Dashboard>
  //   );
  // }

  return (
    <Dashboard headerTitle="Pagos">
      <h1 className="text-xl">Seleccione el cliente para consultar su pago</h1>
      {isLoading && <ProgressSpinner />}
      {/* Excluir PDVSA del pago */}
      <DataTable value={clients?.filter(client => client.name !== "PDVSA") || []}>
        <Column field="name" header="Cliente" />
        <Column
          header="Acción"
          body={(item) => (
            <Button
              icon="pi pi-eye"
              label="Ver"
              onClick={() => navigate(`${item.id}`)}
            />
          )}
        />
      </DataTable>

      {/* Modal de insolvencia de pago */}
      <Dialog
        draggable={false}
        visible={showDialog}
        onHide={() => {
          if (showDialog) setShowDialog(false);
        }}
        headerClassName="bg-white pb-0"
        contentClassName="px-4 pt-0 pb-4"
      >
        <h1 className="text-center mt-0">Ups 😢</h1>
        <p className="text-lg text-center">
          Tiene deudas pendientes. Asegúrese de estar al día para seguir
          recibiendo pacientes.
        </p>
        <div className="flex justify-content-center">
          <Button label="Quiero pagar" onClick={() => setShowDialog(false)} />
        </div>
      </Dialog>
    </Dashboard>
  );
}
